import { TrendingUp } from "lucide-react";
import { useT } from "@/context/ContentContext";

const DEFAULTS = [
    { t: "Ouvir", d: "Percebemos o que pretende, as suas prioridades e aquilo que espera da intervenção." },
    { t: "Analisar", d: "Visitamos o imóvel, avaliamos os trabalhos e procuramos identificar condicionantes antes de começar." },
    { t: "Orçamentar", d: "Apresentamos uma proposta clara, com trabalhos, condições e garantias. Consulta-a e adjudica-a na sua Área do Cliente." },
    { t: "Preparar", d: "Planeamos materiais, especialidades e sequência dos trabalhos — e indicamos-lhe a data prevista de execução." },
    { t: "Executar", d: "Executamos e coordenamos os trabalhos. Recebe atualizações com fotografias: o que fizemos e o que acontece a seguir." },
    { t: "Entregar", d: "Verificamos os trabalhos, tratamos dos acabamentos finais e entregamos a obra. O histórico fica sempre disponível." },
];

export default function HomeProcess() {
    const t = useT();
    return (
        <section className="py-16 sm:py-24 bg-white">
            <div className="max-w-6xl mx-auto px-6 sm:px-10">
                <div className="eyebrow mb-6"><TrendingUp className="w-3.5 h-3.5" /> {t("home.process.eyebrow", "O nosso processo")}</div>
                <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05] max-w-3xl">
                    {t("home.process.title", "Um método claro,")} <span className="font-serif-italic text-[hsl(var(--copper))]">{t("home.process.title_accent", "do início ao fim")}</span><span className="text-[hsl(var(--copper))]">.</span>
                </h2>
                <p className="text-[hsl(var(--graphite))]/70 text-lg mt-6 max-w-2xl">
                    {t("home.process.subtitle", "Seis etapas pensadas para reduzir imprevistos e para que saiba sempre em que ponto está a sua obra.")}
                </p>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-14">
                    {DEFAULTS.map((p, i) => {
                        const n = `0${i + 1}`;
                        return (
                            <div key={n} className="card-stone" data-testid={`process-${n}`}>
                                <div className="font-mono text-xs text-[hsl(var(--copper))] mb-2">{n}</div>
                                <h3 className="font-display text-xl font-bold mb-2">{t(`home.process.step${i + 1}.title`, p.t)}<span className="text-[hsl(var(--copper))]">.</span></h3>
                                <p className="text-[hsl(var(--graphite))]/70 text-sm leading-relaxed">{t(`home.process.step${i + 1}.desc`, p.d)}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
